import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/playlist-fill.svg'


const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "truncate inline-block space-x-1 text-sm w-full" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]

import { // api
		getSceneLiveSongsByRecordId
	} from '../../../../queries'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		inject,
		onMounted,
		ref
	} from 'vue'

	
	const __default__ = { name: 'SceneSoundLiveSongs' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		openToTab: {
			type: Number,
			default: 0
		},
		showDetails:{
			type: Function,
			default: () => {return}
		},
		song: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()

	const {t} = useI18n()

	const songList = ref()
	const loading = ref(true)
	const s3: any = inject('s3')

	onMounted(async () => {
		try { // fetching the role's live songs
			loading.value = true

			const recordId = props.song.recordId

			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
			})

			const params = `?script.prerequest=${encodeURI("Set Language")}&script.prerequest.param=${encodeURI(scriptParams)}`
			let res = await getSceneLiveSongsByRecordId(recordId, params)
			const record = res.response.data[0]
			
			songList.value = record.portalData.jobs_live__LIVE_SONGS__jobsLiveID
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}

		try { // fetching song files from s3
			songList.value.forEach((sound: any) => {
				const soundS3Json = JSON.parse(sound?.["jobs_live__live_songs__songs__SONGS_INFO__songID::s3JSONSong"] || "{}")
				const soundKey = soundS3Json?.s3FilePathShortRaw
				
				if(soundKey) {
					let params = {
						Bucket: process.env.VUE_APP_S3_BUCKET,
						Key: soundKey
					}
		
					s3.getSignedUrlPromise('getObject', params).then(
						function (url: string) {
							sound.signedUrl = url
						}, 
						function (err: Error) { 
							throw err
						}
					)
				}
			})
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}
	})

	function hasScore(row: any) {
		return row?.["jobs_live__live_songs__LIVE_SCORES__liveSongsID::_kp_live_scores_id"]
	}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showDetails(null, 'sceneDetails', 5, null))),
        class: "flex justify-start items-center cursor-pointer"
      }, [
        _createVNode(_component_ArrowLeftIcon, { class: "w-5 h-5" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.returnToSound")), 1)
        ])
      ])
    ]),
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noSongs'),
      data: songList.value,
      loading: loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('177'),
          prop: "jobs_live__live_songs__SONGS__songID::name_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('281'),
          prop: "jobs_live__live_songs__songs__ALBUMS__albumID::name_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('282'),
          prop: "jobs_live__live_songs__songs__ARTISTS__artistID::artist_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("audio", {
              controls: "",
              src: row.signedUrl
            }, [
              _createElementVNode("source", {
                src: row.signedUrl,
                type: "audio/mpeg"
              }, null, 8, _hoisted_4),
              _createTextVNode(" " + _toDisplayString(_unref(t)("placeholders.audioNotSupported")), 1)
            ], 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              onClick: ($event: any) => (__props.showDetails(row, 'liveScore', null, __props.song)),
              class: "h-6 w-6 cursor-pointer"
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([hasScore(row) ? 'linked-icon' : 'grayed-icon']),
                src: _imports_0,
                alt: "music icon"
              }, null, 2)
            ], 8, _hoisted_5)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"])
  ]))
}
}

})